import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import dayjs from "dayjs";
import { List } from "linqts";

import ServiceTransaction from "./ServiceTransaction";
import theme from "../../theme";
import { StatementTransaction, StatementInformationDetail } from "../../types/types";
import { formatCurrency } from "../../utils/helpers";
import { useIsMaguireEnabled } from "../../utils/maguireHelper";

export interface WeeklyTransactionProps {
  transactions: (StatementTransaction | StatementInformationDetail)[];
  week: number;
  isWeeklyStatement?: boolean;
}
const WeeklyTransaction = (props: WeeklyTransactionProps) => {
  const isMaguireEnabled = useIsMaguireEnabled();
  if (!props.transactions || props.transactions.length === 0) return null;
  if (isMaguireEnabled) {
    if (props.isWeeklyStatement) {
      const transactions = props.transactions as StatementInformationDetail[];
      const arr = new List<StatementInformationDetail>(transactions);
      const groupedByTxnId = arr.GroupBy((t) => t.transactionId ?? "");
      const uniqueTransactions = Object.values(groupedByTxnId).map((g) => g[0]);
      const transByDate = new List<StatementInformationDetail>(uniqueTransactions)
        .OrderBy((x) => x.transactionDate)
        .GroupBy((t) => t.transactionDate?.toString() ?? "");
      return (
        <Grid item xs={12}>
          {Object.keys(transByDate).map((date, index) => (
            <Grid container key={index}>
              <Grid item xs={12}>
                <span style={{ color: theme.palette.secondary.main }}>{dayjs(date).format("D MMM")}</span>
              </Grid>
              <Grid item xs={12}>
                <Box paddingTop={1} />
                <ServiceTransaction transactions={transByDate[date]} isWeeklyStatement={props.isWeeklyStatement} />
              </Grid>
            </Grid>
          ))}
          <Grid container>
            <Grid item xs={12}>
              <Box paddingTop={2} paddingBottom={2}>
                <Divider />
              </Box>
            </Grid>
            <Grid item xs={9}>
              <Grid container justifyContent="flex-end">
                <span className="color-accent-2">Weekly Total</span>
              </Grid>
            </Grid>
            <Grid item xs={3}>
              <Grid container justifyContent="flex-end">
                <span className="color-accent-2">
                  {formatCurrency(transactions.reduce((sum, current) => sum + (current.totalMovement ?? 0), 0))}
                </span>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    } else {
      const transactions = props.transactions as StatementTransaction[];
      const arr = new List<StatementTransaction>(transactions);
      const transByDate = arr.OrderBy((x) => x.entryDate).GroupBy((t) => t.entryDate?.toString() ?? "");
      return (
        <Grid item xs={12}>
          {Object.keys(transByDate).map((date, index) => (
            <Grid container key={index}>
              <Grid item xs={12}>
                <span style={{ color: theme.palette.secondary.main }}>{dayjs(date).format("D MMM")}</span>
              </Grid>
              <Grid item xs={12}>
                <Box paddingTop={1} />
                <ServiceTransaction transactions={transByDate[date]} isWeeklyStatement={props.isWeeklyStatement} />
              </Grid>
            </Grid>
          ))}
          <Grid container>
            <Grid item xs={12}>
              <Box paddingTop={2} paddingBottom={2}>
                <Divider />
              </Box>
            </Grid>
            <Grid item xs={9}>
              <Grid container justifyContent="flex-end">
                <span className="color-accent-2">Weekly Total</span>
              </Grid>
            </Grid>
            <Grid item xs={3}>
              <Grid container justifyContent="flex-end">
                <span className="color-accent-2">
                  {formatCurrency(transactions.reduce((sum, current) => sum + (current.totalMovement ?? 0), 0))}
                </span>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    }
  } else {
    const transactions = props.transactions as StatementTransaction[];
    const arr = new List<StatementTransaction>(transactions);
    const transByDate = arr.OrderBy((x) => x.entryDate).GroupBy((t) => t.entryDate?.toString() ?? "");
    return (
      <Grid item xs={12}>
        {Object.keys(transByDate).map((date, index) => (
          <Grid container key={index}>
            <Grid item xs={12}>
              <span style={{ color: theme.palette.secondary.main }}>{dayjs(date).format("D MMM")}</span>
            </Grid>
            <Grid item xs={12}>
              <Box paddingTop={1} />
              <ServiceTransaction transactions={transByDate[date]} />
            </Grid>
          </Grid>
        ))}
        <Grid container>
          <Grid item xs={12}>
            <Box paddingTop={2} paddingBottom={2}>
              <Divider />
            </Box>
          </Grid>
          <Grid item xs={9}>
            <Grid container justifyContent="flex-end">
              <span className="color-accent-2">Weekly Total</span>
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <Grid container justifyContent="flex-end">
              <span className="color-accent-2">
                {formatCurrency(transactions.reduce((sum, current) => sum + (current.totalMovement ?? 0), 0))}
              </span>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
};
export default WeeklyTransaction;
